export default {
  loading: {
    id: 'merchant_options_pricing_loading',
    defaultMessage: 'Loading your princing rules...',
  },
}
